import { IQuoteCountObject } from '@/interfaces';
import React, { FC, useState } from 'react';

const TAB_ORDER = ['total', 'inquiry', 'proposed', 'opened', 'draft', 'archived', 'manually-booked'];

const EventSubTabs: FC<{
    tabsCountData: IQuoteCountObject[];
    currentQuoteStage: string;
    quoteStageSetFunction: (stage: string) => void;
}> = ({ tabsCountData, quoteStageSetFunction, currentQuoteStage }) => {
    const [activeTab, setActiveTab] = useState('total');
    const [quoteStage, setQuoteStage] = useState<string>(currentQuoteStage)
    const getTabName = (tab: IQuoteCountObject) => {
        if (tab.status === 'manually-booked') {
            return 'manually booked'
        } else if (tab.status === 'inquiry') {
            return 'lead'
        }
        return tab.status;
    }
    const sortedTabsData = [...tabsCountData].sort(
        (a, b) => TAB_ORDER.indexOf(a.status) - TAB_ORDER.indexOf(b.status)
    );
    return (
        <div
            className='
        bg-white 
        p-1 sm:p-2 
        rounded-lg sm:rounded-full 
        w-full min-w-0 overflow-hidden
      '
        >
            <ul
                className='
          flex justify-start items-center
          flex-nowrap text-center overflow-x-auto
        '
            >
                {sortedTabsData.map((tab: IQuoteCountObject, index) => (
                    <li
                        key={index}
                        onClick={() => {
                            setActiveTab(tab.status);
                            setQuoteStage(tab.status);
                            quoteStageSetFunction(tab.status);
                        }}
                        className={`
                        rounded-full 
                        px-2 py-1 
                        sm:px-4 sm:py-2 
                        text-[10px] sm:text-sm md:text-base
                        cursor-pointer 
                        transition-all duration-200 
                        flex-shrink-0 whitespace-nowrap
                        ${activeTab === tab.status
                                ? 'bg-[#FF5100] text-white shadow-sm'
                                : ' text-gray-800 '
                            }
                        `}
                    >
                        <span className='font-bold'>{tab.count}</span> <span className='capitalize'>{getTabName(tab)}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default EventSubTabs;
